import React from 'react';
import CwTriggerField from '../cwtriggerfield/CwTriggerField';
import css from './CwPillTriggerField.scss';
import PropTypes from 'prop-types';

class CwPillTriggerField extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            displayText: ''
        };
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.value === '') {
            this.setState({ displayText: '' });
        }
    }

    getParentDiv() {
        return this.parentDiv;
    }
    getInputField() {
        return this.cwTriggerField.cwTextField.inputField;
    }

    focus() {
        this.cwTriggerField.cwTextField.focus();
    }

    onChange = (value) => {
        this.setState({ displayText: value });
        this.props.onChange(value);
    }

    render() {

        return (
            <div
                data-cwid={this.props.cwId}
                className={this.props.style}
                ref={(div) => this.parentDiv = div}
            >
                <CwTriggerField
                    cwId={this.props.cwId + '_trigger'}
                    className={css.cwPillTriggerFieldTriggerField}
                    triggerIcon={this.props.triggerIcon}
                    autoComplete="off"
                    ref={(input) => this.cwTriggerField = input}
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    onChange={this.onChange}
                    onKeyDown={this.props.onKeyDown}
                    onKeyUp={this.props.onKeyUp}
                    value={this.state.displayText}
                    disabled={this.props.disabled}
                    invalid={this.props.invalid}
                    onTrigger={this.props.handleTriggerClick}
                    customElement={this.props.pills}
                    customElementClassName={css.cwPillTriggerFieldTriggerField}
                />
                {this.props.children}
            </div>
        );
    };
}

CwPillTriggerField.propTypes = {
    /**
     * Connectwise element id to be used as unique identifier
     */
    cwId: PropTypes.string,
    /**
     * Represents the item that has been selected from the list (or string of custom item entered in if allowCustomEntry set to true). Returns an object {id,name} by default.
     */
    value: PropTypes.any,
    /**
     * Callback function that is fired when combobox's selection changes
     */
    onChange: PropTypes.func,    
    /**
     * Used to control if combobox is valid
     */
    invalid: PropTypes.bool,
    /**
     * Used to disable combobox
     */
    disabled: PropTypes.bool,
    /**
     * Callback function that is fired when the component is focused
     */
    onFocus: PropTypes.func,
    /**
     * Callback function that is fired when the component is blurred
     */
    onBlur: PropTypes.func,
};

CwPillTriggerField.defaultProps = {
    value: [],
};

export default CwPillTriggerField;


// WEBPACK FOOTER //
// ./src/components/cwpilltriggerfield/CwPillTriggerField.jsx